const ITEMS = [
  "UMEÅ → ÖSTERSUND",
  "UMEÅ → SUNDSVALL",
  "UMEÅ → LULEÅ",
  "LÄKARPROGRAMMET · UTPLACERING T6",
  "RUT-AVDRAG 30 %",
  "FAST PRIS I FÖRVÄG",
  "ANSVARSFÖRSÄKRING",
  "BÄRHJÄLP & TRANSPORT",
];

export const EditorialMarquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden bg-[#16a34a] py-5 select-none">
      <div className="animate-marquee flex w-max items-center whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display font-bold text-white text-lg sm:text-xl tracking-wide px-6">{item}</span>
            <span className="w-2 h-2 rounded-full bg-white/40" />
          </span>
        ))}
      </div>
    </div>
  );
};
